/**
 * Small overlay dialogue asking for consent to collect phone number and
 * Telegram username. Shown once after T&C acceptance; dismissed with
 * "Allow" or "Not now".
 */

import { useState } from 'react';
import { api } from '../api/client.ts';
import { useT } from '../i18n/index.tsx';

interface Props {
  onDone: () => void;
}

export function ConsentDialog({ onDone }: Props) {
  const t = useT();
  const [loading, setLoading] = useState(false);

  const handleAllow = async () => {
    setLoading(true);
    try {
      await api.giveConsent();
      onDone();
    } catch {
      setLoading(false);
    }
  };

  const handleSkip = () => {
    onDone();
  };

  return (
    <div className="consent-overlay">
      <div className="consent-dialog">
        <h2 className="consent-dialog__title">{t.consentTitle}</h2>
        <p className="consent-dialog__body">{t.consentBody}</p>
        <div className="consent-dialog__actions">
          <button
            type="button"
            className="button button--primary"
            style={{ flex: 1 }}
            onClick={handleAllow}
            disabled={loading}
          >
            {loading ? '…' : t.consentAllow}
          </button>
          <button
            type="button"
            className="button button--ghost"
            style={{ flex: 1 }}
            onClick={handleSkip}
          >
            {t.consentSkip}
          </button>
        </div>
      </div>
    </div>
  );
}
